export { SimpleEventRegistrants } from './SimpleEventRegistrants';
